import React, { Component } from 'react'
import { observer } from 'mobx-react'
import style from './style.module.less'
import { message, Spin, MagicInput } from 'hljd'

@observer
export default class extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.addEventListener('click', this.evenListener)
    }, 0)
    this.errRef = React.createRef()
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.evenListener)
  }

  evenListener = async () => {
    const { richTextInfo, checkWord } = this.props.store
    if (richTextInfo) {
      const data = (await checkWord(richTextInfo)) || {}
      const { code, keywords } = data
      if (code == 1) {
        return message.error(`存在敏感词 ${keywords.join(',')}`)
      }
    }
    const { pictureList } = this.props.store
    this.props.store.pictureList = pictureList.map(item => ({
      ...item,
      status: false
    }))
  }

  render() {
    const { richTextInfo, richTextChange, checkingWord } = this.props.store
    return (
      <div
        className={style.caseEditor}
        id="setMeal-richText-edit"
        onClick={e => {
          e.nativeEvent.stopImmediatePropagation()
        }}
      >
        <Spin spinning={checkingWord}>
          <div className={style.editorBar}>
            <p className={style.editorTitle}>文本内容</p>
          </div>
          <div
            className={style.editorCenter}
            ref={editorCenter => (this.editorCenter = editorCenter)}
          >
            {/* <CheckInput
            onChange={richTextChange}
            value={richTextInfo}
            errRef={this.errRef}
          >
            <Input
              maxText={5000}
              placeholder="输入文字介绍"
              type="textarea"
              style={{
                width: 290,
                height: 180,
                margin: '8px 1px 10px',
                borderRadius: 0,
                resize: 'none',
                border: 'none'
              }}
              maxTextStyle={{
                marginRight: 20
              }}
            />
          </CheckInput> */}

            <MagicInput.TextArea
              showCount
              countPosition="inner"
              maxLength={5000}
              value={richTextInfo}
              placeholder="输入文字介绍"
              className={style.input}
              style={{
                width: 290,
                height: 180,
                margin: '8px 1px 10px',
                borderRadius: 0,
                resize: 'none',
                border: 'none'
              }}
              onChange={e => richTextChange(e.target.value)}
            />
          </div>
        </Spin>
      </div>
    )
  }
}
